// extracted by mini-css-extract-plugin
export default {"wrapper":"OtpInput_wrapper__UfrzF","typing":"OtpInput_typing__HRlHK","verifying":"OtpInput_verifying__vyG5l","verified":"OtpInput_verified__HBRV1","error":"OtpInput_error__GZmcx"};